__turbopack_context__.v({
  "faq": "faq-module-sass-module__J_cQkG__faq",
  "faqHeadText": "faq-module-sass-module__J_cQkG__faqHeadText",
});
